module.exports = require("userful-chronos-app-common-js/dist/message/messageTypeDefinitions/mapping/MappingMsgDefinations");